import { MenuModel, CerrarModel, Fechas, HeaderModel} from './../models/menu.model';
import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-menu',
  templateUrl: './../views/menu.component.html',
  styleUrls: ['./../css/menu.component.css'],
})

export class MenuComponent{

  public menu: MenuModel;
  public Header : HeaderModel;

  public cerrar : CerrarModel;
  public fechas : Fechas;

  constructor(private _router :Router) {
    this.menu = new MenuModel( "GestorApp", "Crear Paciente", "Buscar Paciente", "Ver Historial de un paciente");
    this.Header = new HeaderModel("Gestor Paciente");


    this.cerrar = new CerrarModel("cerrar sesión");

    this.fechas =new Fechas("","");
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }
  cerrarSesion(){
    localStorage.clear();
    console.log(localStorage);
      this._router.navigate(['login']);
  }

}

/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/
